import ReactDOM from "react-dom";
import "typeface-roboto";
import "styles/global.css";
import App from "App";

ReactDOM.render(<App />, document.getElementById("root"));
